import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { makeDefaultFailedContainer } from 'components/container'
import { Gates } from 'utils/Access'
import { UpgradeModal } from '@driftt/billing-components'
import ConditionalRender from 'components/shared/ConditionalRender'
import './style.styl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions as TrackingActions } from 'app/modules/tracking'
import * as GateSelectors from 'app/modules/gates/selectors'

class Gate extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isUpgradeModalOpen: false
    }
  }

  static propTypes = {
    children: PropTypes.node,
    gates: PropTypes.object.isRequired,
    requiredGates: PropTypes.array.isRequired,
    alternativeGates: PropTypes.array,
    FallbackComponent: PropTypes.node,
    useModal: PropTypes.bool,
    modalText: PropTypes.string,
    modalPlan: PropTypes.string,
    feature: PropTypes.string,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  }

  handleClick = () => {
    const { disableOverlayClick, actions, feature } = this.props
    if (disableOverlayClick) {
      return
    }
    if (feature) {
      actions.track('Gated CTA Clicked', {feature})
    }
    if (this.props.useModal) {
      this.openUpgradeModal()
      return
    }
    this.context.router.push('/settings/billing')
  }

  hasAccess() {
    const { requiredGates, alternativeGates, gates } = this.props
    const hasAlternativeAccess = _.some(_.map(alternativeGates, gate => _.get(gates, gate, false)))
    return _.some(_.map(requiredGates, gate => _.get(gates, gate, false))) || hasAlternativeAccess
  }

  getBillingStep() {
    return this.context.location.query.billingStep
  }

  closeUpgradeModal = () => {
    this.setState({ isUpgradeModalOpen: false })
  }

  openUpgradeModal = () => {
    this.setState({ isUpgradeModalOpen: true})
  }

  render() {
    const { children, FallbackComponent } = this.props
    const { isUpgradeModalOpen } = this.state
    const step = this.getBillingStep()

    if (this.hasAccess() && _.isUndefined(step)) {
      return <div>{children}</div>
    } else {
      return (
        <div className="drift-gated-content" onClick={this.handleClick}>
          {FallbackComponent || <div />}
          <ConditionalRender condition={isUpgradeModalOpen}>
            <UpgradeModal
              onCloseInitiated={this.closeUpgradeModal}
              headLineFeatureText={this.props.modalText}
              planName={this.props.modalPlan}
              isMonthlyBilling={true}
            />
          </ConditionalRender>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    gates: GateSelectors.getGates(state).toJS()
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      track: TrackingActions.track,
    }, dispatch)
  }
}

const GateContainer = connect(mapStateToProps, mapDispatchToProps)(Gate)

const PREMIUM_GATE = 'premium_drift'
const ENTERPRISE_GATE = 'premium_enterprise'

export const PremiumGate = ({ requiredGates = [], alternativeGates = [], ...rest }) => (
  <GateContainer
    requiredGates={[PREMIUM_GATE, ...requiredGates]}
    alternativeGates={alternativeGates}
    {...rest}
  />
)

export const PremiumTeamGate = ({ requiredGates = [], alternativeGates = [], ...rest }) => (
  <GateContainer
    requiredGates={[Gates.PREMIUM_TEAM, ...requiredGates]}
    alternativeGates={alternativeGates}
    {...rest}
  />
)

export const EnterpriseGate = ({ requiredGates = [], alternativeGates = [], ...rest }) => (
  <GateContainer
    requiredGates={[ENTERPRISE_GATE, ...requiredGates]}
    alternativeGates={alternativeGates}
    {...rest}
  />
)

export default GateContainer



// WEBPACK FOOTER //
// ./src/scripts/components/payments/Gates.js